import backofficeService from "@/api/backoffice";

const blobToDataUrl = blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

export default async business => {
  if (!business || !business.imageUrl) return null;
  if (business.imageUrl.startsWith("data:")) return business.imageUrl;

  try {
    const response = await backofficeService.Api().get(
      `business/${business.id}/logo`,
      { responseType: "blob" }
    );
    return await blobToDataUrl(response.data);
  } catch (error) {
    return null;
  }
};
